import { AgentConfig } from '../../types/agent.types';
import { setActiveAgent } from '../slices/agentSlice';
import { switchToAgent } from '../slices/sessionSlice';
import { AppDispatch } from '../store';

/**
 * Select an agent: sets it as the active agent and restores
 * the most recent session for it.
 *
 * If the agent has a redirectUrl, opens it in a new tab instead.
 */
export function selectAgent(dispatch: AppDispatch, agent: AgentConfig): void {
  if (agent.redirectUrl) {
    window.open(agent.redirectUrl, '_blank', 'noopener,noreferrer');
    return;
  }
  dispatch(setActiveAgent(agent));
  dispatch(switchToAgent(agent.id));
}
